export default {
  disabled: {
    title: 'Facturarea nu este gestionată pe platformă',
    description:
      'Abonamentele și facturile nu sunt disponibile deoarece facturarea dintre dvs. și restaurante se realizează în afara platformei. Plățile, situațiile și rapoartele rămân disponibile.',
  },
};
